import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ChatMessage } from '../../../domain/models/chat-message.model';

@Component({
  selector: 'talk-to-your-data-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageListComponent implements OnChanges {
  @Input() messages: readonly ChatMessage[] = [];
  @ViewChild('bottomAnchor') private readonly bottomAnchor?: ElementRef<HTMLElement>;

  /** Ids of the first message of each calendar day, where a day separator is rendered. */
  dayStartMessageIds: Readonly<Record<string, boolean>> = {};

  trackByMessageId(index: number, message: ChatMessage): string {
    return message.id || String(index);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.messages) {
      this.dayStartMessageIds = this.resolveDayStartMessageIds(this.messages || []);
      this.scrollToBottom();
    }
  }

  private resolveDayStartMessageIds(messages: readonly ChatMessage[]): Readonly<Record<string, boolean>> {
    const ids: Record<string, boolean> = {};
    let previousDay: string | null = null;

    messages.forEach((message) => {
      const date = new Date(message.createdAt);

      if (Number.isNaN(date.getTime())) {
        return;
      }

      const day = date.toDateString();

      if (day !== previousDay) {
        ids[message.id] = true;
        previousDay = day;
      }
    });

    return ids;
  }

  // Waits for the DOM to render the updated messages before scrolling the anchor into view.
  private scrollToBottom(): void {
    setTimeout(() => {
      this.bottomAnchor?.nativeElement.scrollIntoView({ block: 'end' });
    });
  }
}
